import i18n from '../../language/index'
import { mydebounce, create_historical_data } from "@/base/base";
import Cookies from "js-cookie";

const historical_records = {
	namespaced: true,
	state: {
		historyDB: "",
		dbName: "historical",
		version: 1,
		objectStore: "",
		storeName: "xys_historical_list",
		historical_record: [], //历史记录
		websql: null, //全局websql对象
		websql_is_show: false, //历史记录开关
		websql_max: 50, //历史记录最大条数
		Pointer: {
			id: 0,
			index: 0,
			state: "last", //两种状态，last正常插入，指针在最后，select：选中状态，
			data: ""
		},
		websql_debounce: null, //历史记录的防抖函数,
		edit_module_name: "", //websql的name属性
		firefox_historical: [], //火狐等兼容用，存内存，刷新失效
		firefox_Pointer_index: 0
	},
	mutations: {
		clear_record: state => {
			state.historical_record = [];
		},
		//插入历史记录
		historical_record_push: (state, obj) => {
			state.historical_record.push(obj);
		},
		//设置指针
		set_Pointer: (state, { obj, pointer_state, val }) => {
			state.Pointer.id = obj.id;
			state.Pointer.index = 0;
			state.Pointer.state = pointer_state ? pointer_state : "last";
			state.Pointer.data = val ? val : "";
		},

		//删除第一个
		del_first: state => {
			state.historical_record.splice(0, 1);
		},

		//清楚所有，重新设置列表
		again_set_list: (state, arr) => {
			state.historical_record = arr;
		},

		//设置指针id
		set_pointer_id: (state, id) => {
			state.Pointer.id = id;
		},

		//设置全局数据
		set_all_date: (state, { rootState, style_data }) => {
			rootState.myRender.body = style_data.body;
			rootState.myRender.header = style_data.header;
			rootState.myRender.footer = style_data.footer;
			rootState.myRender.full_screen_banner =
				style_data.full_screen_banner;
			rootState.myRender.private = style_data.private;
			rootState.myRender.common = style_data.common;
		},

		clear_Pointer_data: state => {
			state.Pointer.data = "";
		},

		websql_open: state => {
			state.websql_is_show = true;
		},

		websql_close: state => {
			state.websql_is_show = false;
		},

		set_edit_module_name: (state, name) => {
			state.edit_module_name = name;
		},
		set_historical_pointer_id: state => {
			if (state.historical_record.length > 0) {
				const last_id =
					state.historical_record[state.historical_record.length - 1]
						.id;
				localStorage.setItem("xys_historical_pointer_id", last_id);
			}
		}
	},
	actions: {
		//websql创建
		websql_create(store) {
			const { commit, dispatch, state, rootState } = store;
			var indexedDB =
				window.indexedDB ||
				window.mozIndexedDB ||
				window.webkitIndexedDB ||
				window.msIndexedDB;
			const request = indexedDB.open(state.dbName, state.version);
			request.onsuccess = function(event) {
				state.historyDB = event.target.result;
				state.objectStore = state.historyDB
					.transaction([state.storeName], "readwrite")
					.objectStore(state.storeName);
				state.websql_debounce = mydebounce(() => {
					dispatch("websql_data_last");
				}, 500);
				console.log("connect indexedDB");
			};
			request.onerror = function(event) {
				console.error("connect indexedDB error");
			};
			request.onupgradeneeded = function(event) {
				// 版本更新
				if (event.oldVersion > 0 && event.oldVersion < state.version) {
					let deleteRequest = indexedDB.deleteDatabase(state.dbName);
					dispatch("websql_create");
					return;
				}
				let db = event.target.result;
				// 创建表单
				let objectStore = db.createObjectStore(state.storeName, {
					keyPath: "id"
				}); //主键
				objectStore.createIndex("id", "id", { unique: true });
				objectStore.createIndex("type", "type", { unique: false });
				objectStore.createIndex("page", "page", { unique: false });
			};
		},

		// 新增数据
		addData(store, data) {
			return new Promise((resolve, reject) => {
				const request = store.state.historyDB
					.transaction([store.state.storeName], "readwrite")
					.objectStore(store.state.storeName)
					.add(data);
				request.onsuccess = function(event) {
					resolve(true);
				};
				request.onerror = error => {
					console.log("新增数据失败", data);
					reject(error);
				};
			});
		},
		// 通过索引查询数据
		getDataByIndex(store, params) {
			const { indexName, indexValue } = params;
			return new Promise((resolve, reject) => {
				const request = store.state.historyDB
					.transaction([store.state.storeName], "readonly")
					.objectStore(store.state.storeName)
					.index(indexName)
					.getAll(indexValue);
				request.onsuccess = function(e) {
					const result = e.target.result;
					resolve(result);
				};
				request.onerror = error => {
					reject(error);
				};
			});
		},
		// 通过索引查询数据
		getDataByID(store, id) {
			return new Promise((resolve, reject) => {
				const request = store.state.historyDB
					.transaction([store.state.storeName], "readonly")
					.objectStore(store.state.storeName)
					.get(id);
				request.onsuccess = function(e) {
					const result = e.target.result;
					resolve(result);
				};
				request.onerror = error => {
					reject(error);
				};
			});
		},

		//初始化插入历史记录,读取网络数据后执行
		async historical_init_INSERT(store, $message) {
			const { commit, dispatch, state, rootState, getters } = store;
			//const record = getters.Revoke_data;
			const record = create_historical_data(rootState, i18n.t('vuex_modules_historical_records_304'));

			//删除不属于当前theme_id的所有历史记录
			const request = state.historyDB
				.transaction([state.storeName], "readwrite")
				.objectStore(state.storeName)
				.openCursor();

			const admin_theme_id =
				Cookies.get("admin_theme_id") +
				"_" +
				Cookies.get("admin_token");
			request.onsuccess = function(e) {
				const cursor = e.target.result;
				console.log("cursor1111111", cursor);
				let deleteRequest;
				if (cursor) {
					if (cursor.value.type != admin_theme_id) {
						deleteRequest = cursor.delete();
						deleteRequest.onerror = function() {
							console.error("delete historical error");
						};
						deleteRequest.onsuccess = function() {
							console.log("delete historical success");
						};
					}
					cursor.continue();
				} else {
					//判断是否存在未保存的数据,无论成功失败，都执行初始化渲染
					dispatch("sql_init_judge", record);
					//初始化历史记录
					// dispatch("is_recovery", $message).finally(() => {
					// });
				}
			};
		},

		//判断是否恢复上次刷新的状态 === 去除
		async is_recovery(store, $message) {
			//查最后一条
			const { commit, dispatch, state, rootState } = store;
			const data_list = await dispatch("getDataByIndex", {
				indexName: "page",
				indexValue: rootState.app.now_page
			});
			if (data_list && data_list.length > 0 && window.localStorage) {
				//保存的历史记录id
				const save_id = localStorage.getItem(
					"xys_historical_pointer_id"
				);
				if (save_id) {
					const last_id = data_list[data_list.length - 1].id;
					console.log("save_id", save_id);
					console.log("last_id", last_id);
					if (last_id != parseInt(save_id)) {
						$message(i18n.t('vuex_modules_historical_records_305'), i18n.t('view_public_topbar_23'), {
							confirmButtonText: i18n.t('view_public_topbar_24'),
							cancelButtonText: i18n.t('view_public_topbar_11'),
							type: "warning"
						})
							.then(() => {
								const sql_data =
									data_list[data_list.length - 1];
								const style_data = JSON.parse(sql_data.data);
								//页面状态改变
								commit("set_all_date", {
									rootState,
									style_data
								});

								//将当前状态插入到历史记录中
								style_data.theme_id = Cookies.get(
									"admin_theme_id"
								);
								style_data.now_page = rootState.now_page;
								const record = create_historical_data(
									style_data,
									i18n.t('vuex_modules_historical_records_306')
								);
								dispatch("websql_INSERT", { data: record });
							})
							.catch(() => {
								localStorage.setItem(
									"xys_historical_pointer_id",
									last_id
								);
							});
					}
				}
			}
			if (data_list && data_list.length == 0 && window.localStorage) {
				//如果列表为空，说明是切换了模板
				localStorage.removeItem("xys_historical_pointer_id");
			}
		},

		//初始化做历史记录的判断
		async sql_init_judge(store, record) {
			const { commit, dispatch, state, rootState } = store;
			//查询当前页面的历史记录
			const res = await dispatch("getDataByIndex", {
				indexName: "page",
				indexValue: rootState.app.now_page
			});
			if (res) {
				console.log("sql_init_judge", res);
				if (res.length === 0) {
					//如果初始化时空记录，则按照当前数据，插入一条
					const res = await dispatch("addData", record);
					localStorage.setItem(
						"xys_historical_pointer_id",
						record.id
					);
					//插入完成，渲染历史记录视图
					dispatch("historical_init_view");
				} else {
					//如果历史记录里面有，则先渲染
					dispatch("historical_init_view").then(() => {
						//渲染完成后，调用插入方法，判断当前状态与上一次刷新最后一个状态是否一致，不一致则插入
						commit("set_edit_module_name", i18n.t('vuex_modules_historical_records_307')); //先修改历史记录名称
						dispatch("websql_data_last");
					});
				}
			}
		},

		//插入的逻辑
		async websql_INSERT(store, { data, fn }) {
			const { commit, dispatch, state, rootState } = store;
			const Result = await dispatch("addData", data);
			if (Result) {
				// delete data.data;
				if (fn) {
					try {
						dispatch(fn);
					} catch (err) {}
				} else {
					commit("historical_record_push", data);
					commit("set_Pointer", { obj: data });
				}
			}
		},

		//历史记录视图初始化
		historical_init_view(store, set_pointer = true) {
			const { commit, dispatch, state, rootState } = store;
			commit("clear_record");
			dispatch("getDataByIndex", {
				indexName: "page",
				indexValue: rootState.app.now_page
			}).then(Result => {
				if (Result.length > 0) {
					for (let i = 0; i < Result.length; i++) {
						const row_data = Result[i];
						delete row_data.data;
						commit("historical_record_push", row_data);

						//初始化指针,循环到最后一个
						if (i == Result.length - 1 && set_pointer) {
							commit("set_Pointer", { obj: row_data });
						}
					}
				}
			});
		},

		//删除第一条记录
		async delect_first_sql(store, id) {
			const { commit, state } = store;
			const request = state.historyDB
				.transaction([state.storeName], "readwrite")
				.objectStore(state.storeName)
				.delete(id);
			request.onsuccess = function() {
				commit("del_first");
			};
		},

		//数据更新。sql插入一条记录
		async websql_data_last(store) {
			console.log("websql_data_last");
			const { commit, dispatch, state, rootState } = store;
			const record = create_historical_data(
				rootState,
				state.edit_module_name
			);

			//选择历史记录的时候，由于视图更新了，防止插入选中的那条
			if (record.data === state.Pointer.data) {
				commit("clear_Pointer_data");
				return;
			}

			//查询最后一条
			const data_list = await dispatch("getDataByIndex", {
				indexName: "page",
				indexValue: rootState.app.now_page
			});
			if (data_list && data_list && data_list.length > 0) {
				const last_data = data_list[data_list.length - 1];
				//在选中前面的历史记录，先删除后面的，再插入新的
				if (state.Pointer.state === "select") {
					// 删除 page 当前页面， id 大于  state.Pointer.id 的数据
					const request = state.historyDB
						.transaction([state.storeName], "readwrite")
						.objectStore(state.storeName)
						.index("page")
						.openCursor(IDBKeyRange.only(rootState.app.now_page));

					request.onsuccess = function(e) {
						const cursor = e.target.result;
						let deleteRequest;
						if (cursor) {
							if (cursor.value.id > state.Pointer.id) {
								deleteRequest = cursor.delete();
								deleteRequest.onerror = function() {
									console.log("delete cursor error");
								};
								deleteRequest.onsuccess = function() {
									console.log("delete cursor success");
								};
							}
							cursor.continue();
						} else {
							dispatch("websql_INSERT", {
								data: record,
								fn: "historical_init_view"
							});
						}
					};
					request.onerror = function(e) {
						console.error("get websql_data_last error");
					};
					request.addEventListener("complete", event => {
						console.log("Transaction was completed");
					});
				}
				//正常插入
				else {
					//判断本次要插入的和记录里最后一条是否一样
					if (record.data != last_data.data) {
						const res = await dispatch("getDataByIndex", {
							indexName: "page",
							indexValue: rootState.app.now_page
						});
						if (res && res.length >= state.websql_max) {
							// 删除第一条
							dispatch("delect_first_sql", res[0].id);
						}
						dispatch("websql_INSERT", { data: record });
					}
				}
			}
		},

		//查找需要的历史记录
		async find_sql(store, { $message, type, id }) {
			const { commit, dispatch, state, rootState, getters } = store;
			let Revoke_id = null;
			if (type === "Revoke") {
				Revoke_id = getters.Revoke_data;
			} else if (type === "Select") {
				Revoke_id = id;
			} else if (type === "Recovery") {
				Revoke_id = getters.Recovery_data;
			}
			// const sql_text = 'SELECT * FROM xys_historical_list WHERE id=?';
			// const sql_data = [Revoke_id];
			if (Revoke_id === null) {
				$message.error(i18n.t('vuex_modules_historical_records_308'));
				return;
			}
			const Result = await dispatch("getDataByID", Revoke_id);
			//sql没数据的时候，才插入
			if (Result && Result.id) {
				const style_data = JSON.parse(Result.data);
				commit("set_all_date", { rootState, style_data });
				commit("set_Pointer", {
					obj: Result,
					pointer_state: "select",
					val: Result.data
				});
			}
		},

		//撤销
		Revoke(store, { event, $message }) {
			const { commit, dispatch, state, rootState } = store;
			if (event.ctrlKey == true && event.keyCode == 90) {
				rootState.app.module_name = "";
				dispatch("find_sql", { $message, type: "Revoke" });
			}
		},

		//恢复
		Recovery(store, { event, $message }) {
			const { commit, dispatch, state, rootState } = store;
			if (event.ctrlKey == true && event.keyCode == 88) {
				rootState.app.module_name = "";
				dispatch("find_sql", { $message, type: "Recovery" });
			}
		}
	},
	getters: {
		Revoke_data(state) {
			const Pointer_id = state.Pointer.id;
			let obj_id = null;
			for (let i = 0; i < state.historical_record.length; i++) {
				if (state.historical_record[i].id == Pointer_id && i != 0) {
					obj_id = state.historical_record[i - 1].id;
				}
			}
			return obj_id;
		},

		Recovery_data(state) {
			const Pointer_id = state.Pointer.id;
			let obj_id = null;
			for (let i = 0; i < state.historical_record.length; i++) {
				if (
					state.historical_record[i].id == Pointer_id &&
					i != state.historical_record.length - 1
				) {
					obj_id = state.historical_record[i + 1].id;
				}
			}

			//根据当前的指针状态，判断是否到底
			if (obj_id) {
				state.Pointer.state = "select";
			} else {
				state.Pointer.state = "last";
			}
			return obj_id;
		}
	}
};

export default historical_records;



// WEBPACK FOOTER //
// ./src/vuex/modules/historical_records.js